import { useEffect } from 'react'
import { Modal, Tooltip } from 'antd'
import classNames from 'classnames'
import { sortableContainer, sortableElement } from 'react-sortable-hoc'
import styles from './index.less'
import useMain from './hooks/useMain'

const Item = ({ dataSource, className }) => {
    return (
        <Tooltip overlay={null} title={dataSource.selectName}>
            <div className={classNames(styles.item, className)}>{dataSource.selectName}</div>
        </Tooltip>
    )
}

const SortableElement = sortableElement(Item)

const List = ({ className, dataSource }) => {
    return (
        <div className={classNames(styles.list, className)}>
            {dataSource.map((item, index) => (
                <SortableElement key={item.key} index={index} dataSource={item} />
            ))}
        </div>
    )
}

const SortableContainer = sortableContainer(List)

const Content = ({ store }) => {
    useEffect(() => {
        store.init()
    }, [])

    const { list, handleSortEnd } = store

    return (
        <div className={styles.container}>
            <div style={{ marginBottom: '3px' }}>拖动以下快捷筛选项可排序：</div>
            <div>
                <SortableContainer
                    axis="xy"
                    helperClass={styles.sortHelper}
                    dataSource={list}
                    onSortEnd={handleSortEnd}
                />
            </div>
        </div>
    )
}

const bodyStyles = {
    padding: '16px 25px'
}

export default ({ visible, quickSearchOptions, onOk, onCancel, ...restProps }) => {
    const store = useMain({ quickSearchOptions, onOk })

    return (
        <Modal
            title="筛选项排序"
            visible={visible}
            width={600}
            bodyStyle={bodyStyles}
            onOk={store.submit}
            onCancel={onCancel}
            {...restProps}
        >
            <Content store={store} />
        </Modal>
    )
}
